import { createTheme } from "@mui/material/styles";

// documentation using a theme: https://material-ui.com/styles/advanced/ (makestyles is the most easy.)

export const baseTheme = createTheme({
  overrides: {
    // Name of component that needs to be overwritten:
    MuiButton: {
      text: {
        padding: "0 30px",
        backgroundColor: "#2A3448",
      },
      // Name of the rule(s)
      contained: {
        // CSS (JSX syntax)
        backgroundColor: "#2A3448",
        color: "#fff",
        "&:hover": {
          backgroundColor: "#4C5465",
        },
        "&:focus": {
          backgroundColor: "#4C5465",
        },
      },
      containedPrimary: {
        "&:hover": {
          backgroundColor: "#0F66BD",
        },
        "&:focus": {
          backgroundColor: "#0F66BD",
        },
      },
    },
  },
  palette: {
    background: {
      default: "#FAFAFA",
      paper: "#fff",
      dark: "#2A3448",
    },
    common: {
      black: "rgba(32, 32, 32, 1)",
      white: "#fff",
    },
    error: {
      contrastText: "#fff",
      dark: "rgba(159, 0, 0, 1)",
      light: "rgba(250, 231, 194, 1)",
      main: "rgba(233, 156, 0, 1)",
    },
    primary: {
      contrastText: "#fff",
      dark: "#0C44AB",
      light: "rgba(142, 202, 255, 1)",
      main: "rgba(234, 234, 234, 1)",
    },
    secondary: {
      contrastText: "#fff",
      dark: "rgba(0, 107, 0, 1)",
      light: "rgba(160, 214, 106, 1)",
      main: "rgba(100, 180, 13, 1)",
    },
    text: {
      disabled: "rgba(0, 0, 0, 0.38)",
      hint: "rgba(0, 0, 0, 0.38)",
      primary: "rgba(42, 52, 72, 1)",
      secondary: "#fff",
    },
  },
  typography: {
    fontFamily: ["Arapey", "'Raleway'", "Commuter Sans Regular"].join(","),
    color: "#3e3e3e",
  },
});
